/**
 * Structured JSON Logger
 * Replace console.log with structured logs for better traceability
 */

type LogLevel = 'debug' | 'info' | 'warn' | 'error';

export type LogContext = Record<string, string | number | boolean | null | undefined>;

interface LogEntry {
  timestamp: string;
  level: LogLevel;
  message: string;
  context?: LogContext;
  error?: {
    name: string;
    message: string;
    stack?: string;
  };
}

function log(level: LogLevel, message: string, errorOrContext?: Error | LogContext, context?: LogContext): void {
  const entry: LogEntry = {
    timestamp: new Date().toISOString(),
    level,
    message,
  };

  // Handle Error object
  if (errorOrContext instanceof Error) {
    entry.error = {
      name: errorOrContext.name,
      message: errorOrContext.message,
      stack: errorOrContext.stack,
    };
    if (context) {
      entry.context = context;
    }
  } else if (errorOrContext) {
    entry.context = errorOrContext;
  }

  // In development, use console for better DX
  if (import.meta.env.DEV) {
    const logFn = level === 'error' ? console.error : level === 'warn' ? console.warn : console.log;
    logFn(`[${level.toUpperCase()}]`, message, errorOrContext, context);
  } else {
    // In production, output structured JSON
    console.log(JSON.stringify(entry));
  }
}

export const logger = {
  debug: (message: string, context?: LogContext) => log('debug', message, context),
  info: (message: string, context?: LogContext) => log('info', message, context),
  warn: (message: string, context?: LogContext) => log('warn', message, context),
  error: (message: string, error: Error, context?: LogContext) => log('error', message, error, context),
};

















